"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediumPageSelect = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalCss_1 = require("../../globalCss");
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var Select_1 = require("./Select");
exports.MediumPageSelect = (0, styled_components_1.default)(function (props) { return React.createElement(Select_1.Select, __assign({}, props)); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t.options-container {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tmax-width: 220px;\n\t\tpadding: ", ";\n\t}\n\t.options-container > div {\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\tborder-radius: ", ";\n\t\tmargin: 2px;\n\t\t", "\n\t\tline-height: ", ";\n\t\tborder-bottom: ", " !important;\n\t}\n\t.options-container > div > div {\n\t\tfont-size: 13px;\n\t\theight: ", ";\n\t\tpadding: 8px !important;\n\t}\n"], ["\n\t.options-container {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tmax-width: 220px;\n\t\tpadding: ", ";\n\t}\n\t.options-container > div {\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\tborder-radius: ", ";\n\t\tmargin: 2px;\n\t\t", "\n\t\tline-height: ", ";\n\t\tborder-bottom: ", " !important;\n\t}\n\t.options-container > div > div {\n\t\tfont-size: 13px;\n\t\theight: ", ";\n\t\tpadding: 8px !important;\n\t}\n"])), globalVars_module_scss_1.default.spacing20, globalVars_module_scss_1.default.spacing30, globalVars_module_scss_1.default.spacing30, globalVars_module_scss_1.default.borderRadius3, globalCss_1.textCenter, globalVars_module_scss_1.default.spacing30, globalVars_module_scss_1.default.border0, globalVars_module_scss_1.default.spacing30);
exports.MediumPageSelect.displayName = 'MediumPageSelect';
var templateObject_1;
